export default (str) => str.replace(/\n/gm, '<br />')
